"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m15.178 11.334-.515.475-.515-.475a.7.7 0 0 1 1.03 0m-.515 1.568q-.12.156-.246.334a6 6 0 0 0-.504.833c-.137.285-.187.488-.187.604 0 .514.424.937.937.937a.94.94 0 0 0 .937-.937c0-.117-.05-.319-.187-.604a6 6 0 0 0-.503-.833 10 10 0 0 0-.247-.334m2.012.561c.17.354.325.782.325 1.21a2.34 2.34 0 0 1-2.337 2.337 2.34 2.34 0 0 1-2.337-2.337c0-.427.155-.855.325-1.21.176-.367.405-.726.622-1.034a12 12 0 0 1 .795-1.005l.057-.064.016-.018.005-.005.002-.003.515.475.515-.475.002.003.005.005.016.018a9 9 0 0 1 .255.294c.162.194.379.465.598.775.217.308.445.667.621 1.034M6.725 3.202a.7.7 0 0 1 .99-.014l.987.96 3.827 3.827a3.02 3.02 0 0 1 0 4.27l-2.187 2.188a3.02 3.02 0 0 1-4.27 0l-2.188-2.187a3.02 3.02 0 0 1 0-4.27L7.21 4.65l-.472-.458a.7.7 0 0 1-.013-.99m1.482 2.431 3.332 3.332c.176.176.303.383.381.603l-7.425-.006a1.61 1.61 0 0 1 .38-.597zm-3.565 5.33q.096.156.232.293l2.187 2.187a1.62 1.62 0 0 0 2.29 0l2.188-2.187q.133-.135.23-.288z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=BackgroundColorIcon20.js.map